// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_block_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingApprovalMode, BiddingApprovalStageApprovers, BiddingApprovalState, BiddingBidSendErrorCategory, BiddingBidSendStatus, BiddingCsvRowStatus, BiddingJepxReconcileOutcome } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { BiddingSpotBidFeeAutoConsiderInput } from "./bidding_spot_model_pb";
import { file_bffuser_v1_bidding_spot_model } from "./bidding_spot_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_block_model.proto.
 */
export const file_bffuser_v1_bidding_block_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_bffuser_v1_bidding_common_model, file_bffuser_v1_bidding_spot_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * ブロック入札 承認依頼 (BFF mirror)。 受渡日単位で 1〜2 本の BlockBid (leg) を束ねる集約 root。
 *
 * @generated from message bffuser.v1.BiddingBlockApprovalRequest
 */
export type BiddingBlockApprovalRequest = Message<"bffuser.v1.BiddingBlockApprovalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 3;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 4;
   */
  approvalState: BiddingApprovalState;

  /**
   * グループ種別。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidGroupType group_type = 5;
   */
  groupType: BiddingBlockBidGroupType;

  /**
   * Leg 明細。 primary は常に存在し、 secondary は LINK / LOOP のみ設定される。
   * 役割を repeated の並び順で表さない (= internalapi.v1.BlockBidApprovalRequest
   * と同じ理由。 送信先の eSLJ が named field で表現している)。
   *
   * @generated from field: bffuser.v1.BiddingBlockBid primary = 6;
   */
  primary?: BiddingBlockBid;

  /**
   * @generated from field: optional bffuser.v1.BiddingBlockBid secondary = 21;
   */
  secondary?: BiddingBlockBid;

  /**
   * 承認申請者 / 申請日時 (= ステータスバー表示用)。
   *
   * @generated from field: optional string requested_by = 7;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 8;
   */
  requestedAt?: Timestamp;

  /**
   * 承認者 / 承認日時。
   *
   * @generated from field: optional string approved_by = 9;
   */
  approvedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp approved_at = 10;
   */
  approvedAt?: Timestamp;

  /**
   * 差戻し日時 / 差戻し理由。
   *
   * @generated from field: optional google.protobuf.Timestamp rejected_at = 11;
   */
  rejectedAt?: Timestamp;

  /**
   * @generated from field: optional string rejected_reason = 12;
   */
  rejectedReason?: string;

  /**
   * JEPX 提出日時。
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 13;
   */
  submittedAt?: Timestamp;

  /**
   * 監査情報。 updated_at は楽観ロック基準値も兼ねる。
   *
   * @generated from field: optional string created_by = 14;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 16;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp;

  /**
   * 送信状態 (= 提出は承認依頼単位の一括処理なので集約に持つ)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 18;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 19;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 20;
   */
  sendErrorDetail: string;

  /**
   * 発注主体 (= どの名義で JEPX に発注するか)。 LINK / LOOP は all-or-nothing で
   * グループ全 leg が同一結果になるため、 leg ごとではなくグループ単位で持つ。
   * UNSPECIFIED は、eBalance の外から出して取り込んだ札で、受渡契約コードが広域マスタに無く
   * 発注主体区分が空欄の時だけ返る (AC-BSP-111b)。 発電として扱わない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 22;
   */
  issuerType: LicenseType;

  /**
   * 承認申請の時点で写した承認者のうち、 次の承認・差戻しを判定する段 (ブロック入札は第 1 段)
   * のエリアごとの承認者 (AC-BSP-098)。 全エリアの承認者に自分が含まれる時だけ承認者で、
   * 空なら承認者 0 人。 承認申請前・申請取消や差戻し後再編集で下書きに戻った後も空。
   *
   * @generated from field: repeated bffuser.v1.BiddingApprovalStageApprovers stage_approvers = 23;
   */
  stageApprovers: BiddingApprovalStageApprovers[];

  /**
   * 応答時点でグループの取下 (AC-BSP-057) を受け付けるか。 backend の値
   * (internalapi.v1.BlockBidApprovalRequest.withdrawable) をそのまま返す。 一覧の「取下」 はこの値で出す。
   * グループを作ったワークフローの完了 (AC-BSP-058) は反映しない (完了済なら RPC は拒否する)。
   *
   * @generated from field: bool withdrawable = 24;
   */
  withdrawable: boolean;

  /**
   * Numbers mirror internalapi.v1.BlockBidApprovalRequest. Field 25 remains
   * intentionally unused because it is not available in the backend mirror.
   *
   * @generated from field: bool needs_review = 26;
   */
  needsReview: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp needs_review_since = 27;
   */
  needsReviewSince?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp sync_updated_at = 28;
   */
  syncUpdatedAt?: Timestamp;

  /**
   * 応答時点で JEPX が受け付けていたかを確かめているグループか (AC-BSP-117)。 backend の値
   * (internalapi.v1.BlockBidApprovalRequest.receipt_checking) をそのまま返す。 true の間は一覧の
   * ステータス列を入札締切の後も「送信中」 で出す。
   *
   * @generated from field: bool receipt_checking = 29;
   */
  receiptChecking: boolean;

  /**
   * 応答時点でグループの「下書きに戻す」 (AC-BSP-117 / AC-BSP-129) を受け付けるか。 backend の値
   * (internalapi.v1.BlockBidApprovalRequest.returnable_to_draft) をそのまま返す。 一覧の
   * 「下書きに戻す」 はこの値で出す。 グループを作ったワークフローの完了 (AC-BSP-058) は反映しない
   * (完了済なら RPC は拒否する)。
   *
   * @generated from field: bool returnable_to_draft = 30;
   */
  returnableToDraft: boolean;

  /**
   * backend の値 (internalapi.v1 の jepx_reconcile_outcome) をそのまま返す (AC-BSP-117 / AC-BSP-130)。
   *
   * @generated from field: bffuser.v1.BiddingJepxReconcileOutcome jepx_reconcile_outcome = 31;
   */
  jepxReconcileOutcome: BiddingJepxReconcileOutcome;

  /**
   * グループを作ったワークフローの業務 ID (internalapi.v1.BlockBidApprovalRequest.workflow_id)。
   * ワークフローなしのグループは未設定。 一括取下から外すかは
   * GetBiddingSpotScreenResponse.block_bulk_withdraw_excluded_workflow_ids で引く。
   *
   * @generated from field: optional string workflow_id = 32;
   */
  workflowId?: string;
};

/**
 * Describes the message bffuser.v1.BiddingBlockApprovalRequest.
 * Use `create(BiddingBlockApprovalRequestSchema)` to create a new message.
 */
export const BiddingBlockApprovalRequestSchema: GenMessage<BiddingBlockApprovalRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 0);

/**
 * List 用 projection。
 *
 * @generated from message bffuser.v1.BiddingBlockApprovalRequestListItem
 */
export type BiddingBlockApprovalRequestListItem = Message<"bffuser.v1.BiddingBlockApprovalRequestListItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 3;
   */
  approvalState: BiddingApprovalState;

  /**
   * @generated from field: bffuser.v1.BiddingBlockBidGroupType group_type = 4;
   */
  groupType: BiddingBlockBidGroupType;

  /**
   * Leg の件数 (= STANDARD=1、 LINK/LOOP=2)。
   *
   * @generated from field: int32 leg_count = 5;
   */
  legCount: number;

  /**
   * 監査情報。
   *
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 8;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;

  /**
   * 送信状態。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 9;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 承認軸の監査情報。
   *
   * @generated from field: optional string requested_by = 10;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 11;
   */
  requestedAt?: Timestamp;

  /**
   * @generated from field: optional string approved_by = 12;
   */
  approvedBy?: string;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 14;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 15;
   */
  sendErrorDetail: string;

  /**
   * 発注主体 (= 一覧の発注主体列)。
   * UNSPECIFIED は、eBalance の外から出して取り込んだ札で、受渡契約コードが広域マスタに無く
   * 発注主体区分が空欄の時だけ返る (AC-BSP-111b)。 発電として扱わない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 16;
   */
  issuerType: LicenseType;

  /**
   * @generated from field: google.protobuf.Timestamp sync_updated_at = 19;
   */
  syncUpdatedAt?: Timestamp;

  /**
   * backend の値 (internalapi.v1 の jepx_reconcile_outcome) をそのまま返す (AC-BSP-117 / AC-BSP-130)。
   *
   * @generated from field: bffuser.v1.BiddingJepxReconcileOutcome jepx_reconcile_outcome = 20;
   */
  jepxReconcileOutcome: BiddingJepxReconcileOutcome;
};

/**
 * Describes the message bffuser.v1.BiddingBlockApprovalRequestListItem.
 * Use `create(BiddingBlockApprovalRequestListItemSchema)` to create a new message.
 */
export const BiddingBlockApprovalRequestListItemSchema: GenMessage<BiddingBlockApprovalRequestListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 1);

/**
 * ブロック入札 1 leg (BFF mirror)。 1 本の連続コマ入札を表す。
 *
 * @generated from message bffuser.v1.BiddingBlockBid
 */
export type BiddingBlockBid = Message<"bffuser.v1.BiddingBlockBid"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string block_bid_approval_request_id = 2;
   */
  blockBidApprovalRequestId: string;

  /**
   * Leg 種別 (= BLOCK / LINK_BLOCK_P / LINK_BLOCK_C / LOOP_BLOCK_A / LOOP_BLOCK_B)。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidType block_bid_type = 3;
   */
  blockBidType: BiddingBlockBidType;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 4;
   */
  deliveryDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * 売/買 方向。
   *
   * @generated from field: bfftypes.v1.Side direction = 6;
   */
  direction: Side;

  /**
   * 入札価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 7;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 約定状態 (= all-or-nothing でグループ全 leg が同一状態)。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidStatus bid_status = 8;
   */
  bidStatus: BiddingBlockBidStatus;

  /**
   * コマ明細 (= 各コマの入札量・約定量)。
   *
   * @generated from field: repeated bffuser.v1.BiddingBlockBidTimeSlot time_slots = 9;
   */
  timeSlots: BiddingBlockBidTimeSlot[];

  /**
   * JEPX 提出後の入札 ID (= 入札番号、 JEPX が発番する。 未送信は空)。
   *
   * @generated from field: optional string jepx_bid_no = 10;
   */
  jepxBidNo?: string;

  /**
   * Leg ごとの自由記述メモ (deprecated)。 memo_free / memo_jepx に分離した
   * (AC-BSP-030)。 field 番号の再利用を避けるため削除せず維持するが、 以後の
   * 書込は行わない (常に unset で返る)。
   *
   * @generated from field: optional string note = 11 [deprecated = true];
   * @deprecated
   */
  note?: string;

  /**
   * 監査情報。
   *
   * @generated from field: optional string created_by = 12;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない (旧 note の分離後継)。
   *
   * @generated from field: optional string memo_free = 14;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄。 JEPX へ note として送信される記入欄
   * (spec spot-bidding.md AC-BSP-030)。
   *
   * @generated from field: optional string memo_jepx = 15;
   */
  memoJepx?: string;

  /**
   * 受渡契約コード (= 発注主体区分×入札エリア×受渡日から広域マスタを解決した BG
   * コード or 計画提出者コード。 ユーザーの自由入力ではなく読み取り専用の応答値)。
   * 作成・更新時に決めて leg に保存したコードで、 保存前の旧い leg は未設定。
   * 取り込んだ札 (AC-BSP-109) は eSLJ が返したコードをそのまま持ち、 広域マスタに無いコードもありうる
   * (その札のグループは issuer_type が空欄。 AC-BSP-111b)。
   *
   * @generated from field: optional string delivery_contract_code = 16;
   */
  deliveryContractCode?: string;
};

/**
 * Describes the message bffuser.v1.BiddingBlockBid.
 * Use `create(BiddingBlockBidSchema)` to create a new message.
 */
export const BiddingBlockBidSchema: GenMessage<BiddingBlockBid> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 2);

/**
 * ブロック入札 1 leg の 1 コマ (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingBlockBidTimeSlot
 */
export type BiddingBlockBidTimeSlot = Message<"bffuser.v1.BiddingBlockBidTimeSlot"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string block_bid_id = 2;
   */
  blockBidId: string;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 3;
   */
  timeCode: number;

  /**
   * 入札量 (MWh)。
   *
   * @generated from field: google.type.Decimal volume_mwh = 4;
   */
  volumeMwh?: Decimal;

  /**
   * 約定単価 (円/kWh) / 約定電力量 (MWh)。 約定したコマのみ。
   *
   * @generated from field: optional google.type.Decimal contract_price_yen_per_kwh = 5;
   */
  contractPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal contract_volume_mwh = 6;
   */
  contractVolumeMwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingBlockBidTimeSlot.
 * Use `create(BiddingBlockBidTimeSlotSchema)` to create a new message.
 */
export const BiddingBlockBidTimeSlotSchema: GenMessage<BiddingBlockBidTimeSlot> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 3);

/**
 * 書込側の leg 明細。 Create / Update Request の `primary` / `secondary` で使う。
 * leg の役割 (BiddingBlockBidType) は持たない — group_type と primary / secondary
 * のどちらに入れたかで一意に決まるため backend が導出する。
 *
 * @generated from message bffuser.v1.BiddingBlockBidInput
 */
export type BiddingBlockBidInput = Message<"bffuser.v1.BiddingBlockBidInput"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 4;
   */
  direction: Side;

  /**
   * 入札価格 (円/kWh)。 fee_auto_consider を指定しない時だけ設定する。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 5;
   */
  priceYenPerKwh?: Decimal;

  /**
   * コマ明細 (1 件以上、 最大 48 コマ)。
   *
   * @generated from field: repeated bffuser.v1.BiddingBlockBidTimeSlotInput time_slots = 6;
   */
  timeSlots: BiddingBlockBidTimeSlotInput[];

  /**
   * Leg ごとの自由記述メモ (deprecated)。 memo_free / memo_jepx に分離した
   * (AC-BSP-030)。 field 番号の再利用を避けるため削除せず維持するが、 以後は
   * 無視される (memo_free / memo_jepx を使うこと)。
   *
   * @generated from field: optional string note = 7 [deprecated = true];
   * @deprecated
   */
  note?: string;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない。 100 文字以内 (任意)。
   *
   * @generated from field: optional string memo_free = 8;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄。 JEPX へ note として送信される。 70 文字以内 (任意、 spec
   * spot-bidding.md AC-BSP-030)。
   *
   * @generated from field: optional string memo_jepx = 9;
   */
  memoJepx?: string;

  /**
   * 希望価格とプレビュー時の手数料自動考慮 (スポット) の状態。 意味は internalapi.v1.BlockBidInput
   * の同名 field に従う。
   *
   * @generated from field: bffuser.v1.BiddingSpotBidFeeAutoConsiderInput fee_auto_consider = 10;
   */
  feeAutoConsider?: BiddingSpotBidFeeAutoConsiderInput;
};

/**
 * Describes the message bffuser.v1.BiddingBlockBidInput.
 * Use `create(BiddingBlockBidInputSchema)` to create a new message.
 */
export const BiddingBlockBidInputSchema: GenMessage<BiddingBlockBidInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 4);

/**
 * 書込側のコマ明細。
 *
 * @generated from message bffuser.v1.BiddingBlockBidTimeSlotInput
 */
export type BiddingBlockBidTimeSlotInput = Message<"bffuser.v1.BiddingBlockBidTimeSlotInput"> & {
  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 1;
   */
  timeCode: number;

  /**
   * 入札量 (MWh)。
   *
   * @generated from field: google.type.Decimal volume_mwh = 2;
   */
  volumeMwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingBlockBidTimeSlotInput.
 * Use `create(BiddingBlockBidTimeSlotInputSchema)` to create a new message.
 */
export const BiddingBlockBidTimeSlotInputSchema: GenMessage<BiddingBlockBidTimeSlotInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 5);

/**
 * ブロック入札 CSV の差分プレビュー 1 行 (BFF mirror、 backend `BlockBidCsvRowResult` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingBlockCsvRowResult
 */
export type BiddingBlockCsvRowResult = Message<"bffuser.v1.BiddingBlockCsvRowResult"> & {
  /**
   * CSV のデータ行番号 (ヘッダー行を除く 1 起算)。 エラー文言の「行 N」 と一致する。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.BiddingCsvRowStatus status = 2;
   */
  status: BiddingCsvRowStatus;

  /**
   * 表示用のエラー理由。 status = ERROR の時のみ非空。
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * 「売買」列 (買 / 売) から判定した売買方向 (コマ列は絶対値のみで符号を持たない)。
   *
   * @generated from field: bfftypes.v1.Side direction = 6;
   */
  direction: Side;

  /**
   * `価格 (円/kWh)` 列の値 (手数料自動考慮が OFF なら入札価格、 ON なら希望価格。
   * AC-BSP-004b)。 手数料自動考慮の導入前から「価格列の値」を常に設定する field
   * なので意味を変えない。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 7;
   */
  orderPriceYenPerKwh?: Decimal;

  /**
   * 対象コマの連続範囲 (開始・終了コマ番号、 1〜48)。
   *
   * @generated from field: int32 start_time_code = 8;
   */
  startTimeCode: number;

  /**
   * @generated from field: int32 end_time_code = 9;
   */
  endTimeCode: number;

  /**
   * CSV 内のペア識別キー。 STANDARD_BLOCK では空。
   *
   * @generated from field: string pair_no = 10;
   */
  pairNo: string;

  /**
   * ペア内の役割 (LINK: P / C、 LOOP: A / B)。 STANDARD_BLOCK では空。
   *
   * @generated from field: string block_type = 11;
   */
  blockType: string;

  /**
   * 行の発注主体区分 (AC-DSB-016)。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 12;
   */
  issuerType: LicenseType;

  /**
   * JEPX へ送る自由記述。 emission_factor_linked の行はシステムが組み立てた判別コメント
   * (AC-DSB-030)。
   *
   * @generated from field: string jepx_free_text = 13;
   */
  jepxFreeText: string;

  /**
   * 排出係数紐付けが 1 の行 (= jepx_free_text が組み立て後の判別コメント)。
   *
   * @generated from field: bool emission_factor_linked = 14;
   */
  emissionFactorLinked: boolean;

  /**
   * 内部用のメモ (JEPX へは送らない)。
   *
   * @generated from field: string memo = 15;
   */
  memo: string;

  /**
   * 手数料自動考慮 ON で order_price_yen_per_kwh (希望価格) から算出した入札価格
   * (AC-BSP-004b)。 OFF の場合は未設定 (order_price_yen_per_kwh の値をそのまま
   * 入札価格として使う)。
   *
   * @generated from field: google.type.Decimal fee_adjusted_order_price_yen_per_kwh = 16;
   */
  feeAdjustedOrderPriceYenPerKwh?: Decimal;

  /**
   * 既存の札と重複するブロックの行への警告 (AC-DSB-034)。 リンクブロック・ループは 2 行とも。
   * 重複しない行・エラー行は空。 取込は止めない。
   *
   * @generated from field: string duplicate_warning = 17;
   */
  duplicateWarning: string;
};

/**
 * Describes the message bffuser.v1.BiddingBlockCsvRowResult.
 * Use `create(BiddingBlockCsvRowResultSchema)` to create a new message.
 */
export const BiddingBlockCsvRowResultSchema: GenMessage<BiddingBlockCsvRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_model, 6);

/**
 * ブロック入札グループ種別 (BFF mirror、 backend `internalapi.v1.BlockBidGroupType` と 1:1)。
 * domain valueobject.BlockBidGroupType の integer 値 (1-3) と対応。
 *
 * @generated from enum bffuser.v1.BiddingBlockBidGroupType
 */
export enum BiddingBlockBidGroupType {
  /**
   * @generated from enum value: BIDDING_BLOCK_BID_GROUP_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 通常ブロック (single leg)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_GROUP_TYPE_BLOCK = 1;
   */
  BLOCK = 1,

  /**
   * リンクブロック (primary + secondary leg。 primary が約定する場合のみ secondary が約定対象)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_GROUP_TYPE_LINK_BLOCK = 2;
   */
  LINK_BLOCK = 2,

  /**
   * ループブロック (A leg + B leg。 双方成立時のみ約定)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_GROUP_TYPE_LOOP_BLOCK = 3;
   */
  LOOP_BLOCK = 3,
}

/**
 * Describes the enum bffuser.v1.BiddingBlockBidGroupType.
 */
export const BiddingBlockBidGroupTypeSchema: GenEnum<BiddingBlockBidGroupType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_block_model, 0);

/**
 * ブロック入札 leg 種別 (BFF mirror、 backend `internalapi.v1.BlockBidType` と 1:1)。
 * domain valueobject.BlockBidType の integer 値 (1-5) と対応。
 *
 * @generated from enum bffuser.v1.BiddingBlockBidType
 */
export enum BiddingBlockBidType {
  /**
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 通常ブロックの単独 leg。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_BLOCK = 1;
   */
  BLOCK = 1,

  /**
   * リンクブロックの親 leg (primary)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_LINK_BLOCK_P = 2;
   */
  LINK_BLOCK_P = 2,

  /**
   * リンクブロックの子 leg (secondary)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_LINK_BLOCK_C = 3;
   */
  LINK_BLOCK_C = 3,

  /**
   * ループブロックの A leg (primary)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_LOOP_BLOCK_A = 4;
   */
  LOOP_BLOCK_A = 4,

  /**
   * ループブロックの B leg (secondary)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_TYPE_LOOP_BLOCK_B = 5;
   */
  LOOP_BLOCK_B = 5,
}

/**
 * Describes the enum bffuser.v1.BiddingBlockBidType.
 */
export const BiddingBlockBidTypeSchema: GenEnum<BiddingBlockBidType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_block_model, 1);

/**
 * ブロック入札 leg の約定状態 (BFF mirror、 backend `internalapi.v1.BlockBidStatus` と 1:1)。
 * all-or-nothing のためグループ全 leg が同一状態に遷移する。
 * domain valueobject.BlockBidStatus の integer 値と対応。
 * 5 は通常入札の失効 (BIDDING_SPOT_BID_STATUS_EXPIRED) と同じ番号。
 *
 * @generated from enum bffuser.v1.BiddingBlockBidStatus
 */
export enum BiddingBlockBidStatus {
  /**
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 約定待ち (= JEPX 一斉約定前)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * 約定 (= グループ全 leg・全コマ約定)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_MATCHED = 2;
   */
  MATCHED = 2,

  /**
   * 不約定 (= all-or-nothing で全 leg・全コマ不成立)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_UNMATCHED = 3;
   */
  UNMATCHED = 3,

  /**
   * 失敗。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * 失効 (= JEPX に届かないまま入札締切を過ぎた。 約定対象外)。 締切まで下書き・承認待ち・差戻しのまま
   * 提出されなかった (AC-BSP-099、 承認ステータスは N/A に戻る) か、 締切までに JEPX へ送信できなかった
   * (AC-BSP-011 / AC-BSP-117)。 グループ全 leg が同時にこの状態になる。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,

  /**
   * 取消 (= 取下成立)。 グループ全 leg が同時にこの状態になる。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * 取下処理中 (= JEPX 取消 API 呼び出し中 / リトライ中)。
   * ステータス列の表示は「入札中」 のまま維持する (AC-BSP-057b)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_WITHDRAWING = 7;
   */
  WITHDRAWING = 7,

  /**
   * 取下失敗 (= 入札締切到達で確定)。
   *
   * @generated from enum value: BIDDING_BLOCK_BID_STATUS_WITHDRAW_FAILED = 8;
   */
  WITHDRAW_FAILED = 8,
}

/**
 * Describes the enum bffuser.v1.BiddingBlockBidStatus.
 */
export const BiddingBlockBidStatusSchema: GenEnum<BiddingBlockBidStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_block_model, 2);

/**
 * BlockBidWriteBlockedReason mirrors backend
 * internalapi.v1.BlockBidWriteBlockedReason 1:1 (wire value names match). See
 * the backend enum's godoc for the typed-vocabulary contract (not a wire
 * message field; google.rpc.ErrorInfo.reason stays a generic string)。
 * 生成された TS enum と `Record<BlockBidWriteBlockedReason, entry | undefined>`
 * により frontend は全 reason の網羅を tsc で担保する。
 *
 * 値名は backend 側と完全一致させる (frontend は
 * google.rpc.ErrorInfo.reason の文字列をこの mirror の descriptor で解決する
 * ため。 adapter/grpc/interceptor/error_reason_mirror_test.go が pin する)。
 *
 * @generated from enum bffuser.v1.BlockBidWriteBlockedReason
 */
export enum BlockBidWriteBlockedReason {
  /**
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 組織設定の入札制限に違反するコマが含まれる (AC-BDL-008 / AC-BSP-104)。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_BID_LIMIT_VIOLATION = 1;
   */
  BID_LIMIT_VIOLATION = 1,

  /**
   * 上限数量(コマ計) を超えるコマがある (AC-BSP-104)。 metadata の形は
   * internalapi.v1 側の定義に従う。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_BID_VOLUME_TOTAL_LIMIT_VIOLATION = 2;
   */
  BID_VOLUME_TOTAL_LIMIT_VIOLATION = 2,

  /**
   * 入札締切 (受渡日前日 10:00 JST) を過ぎている (AC-BSP-013 / AC-BSP-056c)。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_GATE_CLOSURE = 3;
   */
  GATE_CLOSURE = 3,

  /**
   * 手数料自動考慮 (スポット) の状態がプレビュー時と違う、 または ON なのに手数料単価を使えない
   * (AC-BSP-004b)。 画面はプレビューを取り直す。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_FEE_AUTO_CONSIDER_CHANGED = 4;
   */
  FEE_AUTO_CONSIDER_CHANGED = 4,

  /**
   * 手数料自動考慮 ON で算出したいずれかの Leg の入札価格が値域・入札制限を外れる (AC-BSP-106)。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 5;
   */
  FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 5,

  /**
   * 「下書きに戻す」 の時点で送信の最中 (AC-BSP-117)。 グループは変わらない。 送信が終われば押し直せる。
   *
   * @generated from enum value: BLOCK_BID_WRITE_BLOCKED_REASON_BID_SEND_IN_FLIGHT = 6;
   */
  BID_SEND_IN_FLIGHT = 6,
}

/**
 * Describes the enum bffuser.v1.BlockBidWriteBlockedReason.
 */
export const BlockBidWriteBlockedReasonSchema: GenEnum<BlockBidWriteBlockedReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_block_model, 3);

